/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const charger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6 10.75c-3.789 0-3.919-2.049-3.919-5.653 0-.148.024-.415.212-.603A1 1 0 0 1 3 4.201h1m2 6.549c3.558 0 4-2.049 4-5.549a1 1 0 0 0-1-1H8M6 10.75v2c0 2.833 4 2.833 4 0 0-2.5 4-2.5 4 0v3M4 .75v3.451M8 .75v3.451m0 0H4"
    />
  </svg>
)
export default charger
